import { formatFAmount } from '@/shared/utils/finacalNumber';
import { Popup } from 'vant';
import {
  Component, Vue, Model, Watch,
} from 'vue-property-decorator';

import { namespace } from 'vuex-class';

import {
  DUXIAOMAN_COMMODITY,
  JUZI_COMMODITY,
  // NEWORAGE_COMMODITY,
  XIAOXIANG_COMMODITY,
} from '@/shared/commodity';
import style from './index.module.scss';

// 目前中断订单流程 只有 度小满，桔多多，小象优品渠道

type ProductVo = Dictionary<{
  productName: string;
}>;

const productIDToName: ProductVo = {
  [DUXIAOMAN_COMMODITY]: {
    productName: '度小满',
  },
  // [NEWORAGE_COMMODITY]: {
  //   productName: '桔多多钱包',
  // },
  [XIAOXIANG_COMMODITY]: {
    productName: '小象优品',
  },
  [JUZI_COMMODITY]: {
    productName: '桔多多',
  },
};


const ApplyProductStore = namespace('applyProduct');
@Component({
  name: 'BreakApplyPopup',
})

export default class BreakApplyPopup extends Vue {
  @ApplyProductStore.State brokenAmount!: number | undefined;

  @ApplyProductStore.State canCancel!: boolean | false;

  @ApplyProductStore.State brokenProductId!: string;

  private get commodityIdChannel() {
    // 获取中断的渠道 id
    return this.brokenProductId ? this.brokenProductId : '';
  }

  private get commodityName(): string {
    return this.commodityIdChannel ? productIDToName[this.commodityIdChannel].productName : '';
  }

  @Model('change', {
    type: Boolean,
  })
  private brokenPop!: boolean

  // 关闭
  private onClosedPopup() {
    this.$emit('close');
  }

  // 验证并提现
  private confirmSms() {
    this.$ubtPageButton(
      'finance_click_ShortMessage_Confirmation',
      'commodityId',
      this.commodityIdChannel,
    );
    this.$emit('confirm');
  }

  /** 取消中断订单 */
  private cancel() {
    this.$ubtPageButton(
      'finance_click_ShortMessage_giveUp',
      'commodityId',
      this.commodityIdChannel,
    );
    this.$emit('cancel');
  }

  @Watch('brokenPop')
  private popVisale(val: boolean) {
    // 弹窗显示 曝光埋点
    if (val) {
      this.$ubtModuleExpose(
        'finance_shortMessage_Confirmation',
        'commodityId',
        this.commodityIdChannel,
      );
    }
  }

  private render() {
    return (
      <div class={style.breakApplyPopup}>
        <Popup
          class={style.popupRadius}
          v-model={this.brokenPop}
          position='bottom'
          closeOnClickOverlay={false}
        >
          <section class={style.mainContent}>
            <div class={style.navContent}>
              <div class={style.title}>
                <span>成功提现就差最后一步验证</span>
                <span class={style.closed} onClick={this.onClosedPopup.bind(this)}></span>
              </div>
              <div class={style.contentWrapper}>
                {/* <p class={style.brokenTitle}>成功提现就差最后一步验证</p> */}
                <p class={style.amountText}>
                  在 <span class={style.commodityName}>{this.commodityName}</span> 的提现金额
                </p>
                <div class={style.moneyText}>
                  <span>¥</span>
                  <span class={style.moneyAmount}>{formatFAmount(this.brokenAmount || '')}</span>
                </div>
                <div class={style.footer}>
                  {this.canCancel && <div
                    class={[
                      style.cancelText,
                      this.canCancel && style.footerBtn,
                    ]}
                    onClick={this.cancel.bind(this)}
                  >放弃本次提现</div>}
                  <div
                    class={[
                      style.confirmText,
                      this.canCancel && style.footerBtn,
                    ]}
                    onClick={this.confirmSms.bind(this)}
                  >
                    验证并提现</div>
                </div>
                {/* <p class={style.tips}>验证码5分钟内有效</p> */}
              </div>
            </div>
          </section>

        </Popup>
      </div>
    );
  }
}
